/* This file was generated automatically. Do not edit manually. */

import { createPortfolioAccountingCategoriesRepository as portfolioAccountingCategories } from './portfolioAccountingCategories';
import { createPortfolioCentralCancellationPoliciesRepository as portfolioCentralCancellationPolicies } from './portfolioCentralCancellationPolicies';
import { createPortfolioCentralPaymentAndCancellationPoliciesRepository as portfolioCentralPaymentAndCancellationPolicies } from './portfolioCentralPaymentAndCancellationPolicies';
import { createPortfolioCentralPaymentPoliciesRepository as portfolioCentralPaymentPolicies } from './portfolioCentralPaymentPolicies';
import { createPortfolioCentralProductsRepository as portfolioCentralProducts } from './portfolioCentralProducts';
import { createPortfolioCentralRateGroupsRepository as portfolioCentralRateGroups } from './portfolioCentralRateGroups';
import { createPortfolioEnterpriseGroupsRepository as portfolioEnterpriseGroups } from './portfolioEnterpriseGroups';
import { createPortfolioEnterpriseProductsRepository as portfolioEnterpriseProducts } from './portfolioEnterpriseProducts';
import { createPortfolioEnterpriseRelationshipsRepository as portfolioEnterpriseRelationships } from './portfolioEnterpriseRelationships';
import { createPortfolioProductsRepository as portfolioProducts } from './portfolioProducts';
import { createPortfolioRateGroupsRepository as portfolioRateGroups } from './portfolioRateGroups';
import { createPortfolioRatesRepository as portfolioRates } from './portfolioRates';
import { createPortfolioServicesRepository as portfolioServices } from './portfolioServices';
import { createPortfolioVouchersRepository as portfolioVouchers } from './portfolioVouchers';

export * from './types';

export const portfolioApiBasePath = '/api/portfolio/v1';

export const portfolioRestRepositoryFactories = {
    portfolioAccountingCategories,
    portfolioCentralCancellationPolicies,
    portfolioCentralPaymentAndCancellationPolicies,
    portfolioCentralPaymentPolicies,
    portfolioCentralProducts,
    portfolioCentralRateGroups,
    portfolioEnterpriseGroups,
    portfolioEnterpriseProducts,
    portfolioEnterpriseRelationships,
    portfolioProducts,
    portfolioRateGroups,
    portfolioRates,
    portfolioServices,
    portfolioVouchers,
};
